var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('AppAlert'),(_vm.userAtivo && !_vm.loading)?_c('AppMenu'):_vm._e(),(_vm.userAtivo && !_vm.loading)?_c('AppBar'):_vm._e(),(!_vm.loading)?_c('AppContent'):_vm._e(),(_vm.loading)?_c('AppLoading'):_vm._e(),_c('ConfirmDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }